<template>
  <v-card>
    <div>
      <v-card-title class="primary"><h3 style="color: white">ARQUIVOS</h3> </v-card-title>
      <v-divider></v-divider>
        <v-container>
          <v-layout row wrap>
            <v-flex
              v-for="arquivo in arquivosListProp"
              :key="arquivo.id"
              md12
              xs12
            >
              <v-tooltip bottom color="blue darken-1">
                <v-btn
                  style="
                    padding: -20px 0px 0px 0px;
                    margin: -10px 0px 0px 0px;
                    width: 100%;
                  "
                  class="btn-download-arquivo"
                  slot="activator"
                  icon

                  @click.native="gerarArquivo(arquivo.id, arquivo.contentType,arquivo.originalFilename)"
                >

                  <p class="mb-0 body-1 ">{{arquivo.originalFilename.substring(0, 40).concat("...")}}</p>
                  <v-icon text-xs-right color="#00456e">get_app</v-icon>
                  <p class="mb-0 pl-3 body-1 "> {{ "("+ bytesToSize(arquivo.size)+"MB)" }}</p>
                </v-btn>
                <div style="text-align: center">Download</div>
              </v-tooltip>
            </v-flex>
          </v-layout>
        </v-container>
      <v-card-actions>
        <v-btn color="blue darken-1" flat @click="$emit('fechar')">Fechar</v-btn>
      </v-card-actions>
    </div>
  </v-card>


</template>

<script>
import axios from "axios";''
import usuarioHelper from "@/helpers/usuario-logado.js";

export default {
  name: "ModalArquivo",
  props: {
    arquivosListProp: {
      type: Array,
    }
  },

  methods: {
    gerarArquivo(id,tipo,nome) {
    this.$store.commit("startLoading");
      if(usuarioHelper.USUARIO_LOGADO().perfil.id == 1 || usuarioHelper.USUARIO_LOGADO().perfil.id == 4) {

        return axios({
          url: `${process.env.URL_CORRETORMS}/v1/gerarArquivoCorretorReserva/${id}`,
          method: "GET",
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
          })
          .then(response => {

            var blob = new Blob([response.data], { type: tipo });
            var url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.download = nome;
            link.href = url;
            link.click();
            this.$store.commit("endLoading");

          })
          .catch(err => {
            this.$store.commit("endLoading");
          })
      }
    },
    bytesToSize(bytes) {
      if (bytes === 0) return 0
      const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10)
      if (i === 0) return 0
      return (bytes / (1024 ** i)).toFixed(1)
    }
  }
}
</script>

<style>
.btn-download-arquivo {
  background-color: transparent!important;
  box-shadow: none!important;
  border: 0!important;
}
.btn-download-arquivo .v-btn--active::before, .v-btn:hover::before, .v-btn:focus::before {
  background-color: transparent!important;
}
.btn-download-arquivo p {
  transition: 0.3s ease-in-out;
}
.btn-download-arquivo:hover p {
  text-decoration: underline;
  font-weight: bold;
  text-decoration-color: #00456e;
  color: #00456e;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/corretor-reserva/ModalArquivo.vue